const DEFAULT_AVATAR = 'https://thirdwx.qlogo.cn/mmopen/vi_32/POgEwh4mIHO4nibH0KlMECNjjGxQUq24ZEaGT4poC6icRiccVGKSyXwibcPq4BWmiaIGuG1icwxaQX6grC9VemZoJ8rg/132'

function formatFieldValue(e, fileBaseUrl) {
  if (!e || !e.value) {
    return null
  }
  const label = e.value.name || '未命名'
  switch (e.type) {
    case 'field':
      return {
        label,
        displayValue: e.value.value || '未填写',
        type: 'text',
      }
    case 'radio': {
      const options = e.value.options || []
      const selected = options.find(item => item.value == e.value.value)
      const displayValue = selected
        ? (selected.label || selected.text || selected.value)
        : (e.value.value || '未选择')
      return { label, displayValue, type: 'text' }
    }
    case 'checkbox': {
      const values = Array.isArray(e.value.value) ? e.value.value : []
      const labels = (e.value.options || [])
        .filter(item => values.some(val => val == item.value))
        .map(item => item.label || item.text || item.value)
      return {
        label,
        displayValue: labels.length ? labels.join('、') : '未选择',
        type: 'text',
      }
    }
    case 'switch':
      return {
        label,
        displayValue: e.value.value ? (e.value.right || '是') : (e.value.left || '否'),
        type: 'text',
      }
    case 'date':
      return {
        label,
        displayValue: e.value.value || '未填写',
        type: 'text',
      }
    case 'rate':
      return {
        label,
        displayValue: e.value.value ? `${e.value.value} 星` : '未评分',
        type: 'text',
      }
    case 'img': {
      const imgurl = e.value.value
      const displayValue = imgurl
        ? `${fileBaseUrl.replace(/\/$/, '')}/${String(imgurl).replace(/^\//, '')}`
        : DEFAULT_AVATAR
      return { label, displayValue, type: 'img' }
    }
    default:
      return {
        label,
        displayValue: e.value.value != null ? String(e.value.value) : '未填写',
        type: 'text',
      }
  }
}

export function buildNewsMessageTableRows(row, fileBaseUrl) {
  if (!row) {
    return []
  }
  const rows = []
  if (row.title) {
    rows.push({ label: '企业标题', displayValue: row.title, type: 'text' })
  }
  if (row.nickName) {
    rows.push({ label: '微信昵称', displayValue: row.nickName, type: 'text' })
  }
  if (row.phone) {
    rows.push({ label: '手机号', displayValue: row.phone, type: 'text' })
  }
  if (row.nameCardName) {
    rows.push({ label: '名片名称', displayValue: row.nameCardName, type: 'text' })
  }
  if (row.createdTime) {
    rows.push({ label: '下单时间', displayValue: row.createdTime, type: 'text' })
  }

  let content = []
  try {
    content = JSON.parse(row.content || '[]')
  } catch (e) {
    content = []
  }

  content.forEach(item => {
    const fieldRow = formatFieldValue(item, fileBaseUrl)
    if (fieldRow) {
      rows.push(fieldRow)
    }
  })
  return rows
}

export function buildNewsMessageImageName(row) {
  const newsId = row && row.newsId ? row.newsId : 'detail'
  const time = row && row.createdTime
    ? String(row.createdTime).replace(/[:\s]/g, '-').slice(0, 19)
    : Date.now()
  return `下单详情_${newsId}_${time}.png`
}
